module.exports = __webpack_public_path__ + "static/media/rondflam.12d75966.svg";